import React from 'react';
import { Paper } from '../../../Paper/Paper';
import { Components } from '../../types';
import { StyledExtraItem } from './StyledExtraItem';

export const PaperMuiComponent: NonNullable<Components['Paper']> = ({
  width,
  extraItemText,
  onExtraItemClick,
  paperProps,
  elevation
}) => {
  const { children, ...rest } = paperProps;
  return (
    <Paper style={{ width }} elevation={elevation} {...rest}>
      {children}
      {!!onExtraItemClick && (
        <StyledExtraItem data-test="extra-item-click" className="MuiAutocomplete-option" onMouseDown={onExtraItemClick}>
          {extraItemText ?? '-'}
        </StyledExtraItem>
      )}
    </Paper>
  );
};
